import { Mail, MessageCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export const VARS = ["Nama_Klien", "Nama_Perusahaan", "Nomor_Penawaran", "Nilai_Diskon", "Link_Proposal"];
export const SAMPLE = { Nama_Klien: "Budi Santoso", Nama_Perusahaan: "PT Bangun Karya", Nomor_Penawaran: "RU/2026/10/00125", Nilai_Diskon: "15%", Link_Proposal: "https://rikonstruksiutama.com/proposal" };
export const fillSample = (s) => VARS.reduce((acc, k) => acc.split(`{${k}}`).join(SAMPLE[k]), s || "");

const BADGE = {
  sent: ["Terkirim", "bg-emerald-100 text-emerald-800 ring-emerald-300"], delivered: ["Delivered", "bg-emerald-100 text-emerald-800 ring-emerald-300"],
  opened: ["Dibuka", "bg-emerald-600 text-white ring-emerald-700"], read: ["Dibaca", "bg-emerald-600 text-white ring-emerald-700"],
  scheduled: ["Terjadwal", "bg-amber-100 text-amber-900 ring-amber-300"], sending: ["Mengirim", "bg-amber-100 text-amber-900 ring-amber-300"],
  failed: ["Gagal", "bg-rose-600 text-white ring-rose-700"], resent: ["Dikirim Ulang", "bg-sky-600 text-white ring-sky-700"],
  cancelled: ["Dibatalkan", "bg-slate-200 text-slate-700 ring-slate-300"], draft: ["Draft", "bg-slate-100 text-slate-700 ring-slate-300"],
  running: ["Berjalan", "bg-amber-100 text-amber-900 ring-amber-300"], completed: ["Selesai", "bg-emerald-100 text-emerald-800 ring-emerald-300"],
};

export const StatusBadge = ({ status, testid }) => {
  const [l, c] = BADGE[status] || [status, "bg-slate-100 text-slate-700 ring-slate-300"];
  return <span className={`inline-flex rounded-md px-2 py-0.5 text-[11px] font-bold ring-1 ${c}`} data-testid={testid}>{l}</span>;
};

export const ChannelIcon = ({ channel, size = 14 }) => channel === "email"
  ? <span className="inline-flex items-center gap-1 text-sky-700"><Mail size={size} /> Email</span>
  : <span className="inline-flex items-center gap-1 text-emerald-700"><MessageCircle size={size} /> WhatsApp</span>;

export const Card = ({ title, action, children, className = "", testid }) => (
  <section className={`rounded-xl border border-slate-200 bg-white shadow-sm ${className}`} data-testid={testid}>
    {title && <div className="flex items-center justify-between border-b border-slate-100 px-6 py-4"><h3 className="text-sm font-bold text-[#0F2B48]">{title}</h3>{action}</div>}
    <div className="p-6">{children}</div>
  </section>
);

export const Kpi = ({ icon: Icon, label, value, tone = "text-[#0F2B48]", testid }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-testid={testid}>
    <div className="flex items-center justify-between"><p className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</p>{Icon && <Icon size={18} className={tone} />}</div>
    <p className={`mt-3 text-3xl font-extrabold ${tone}`}>{value}</p>
  </div>
);

export const Tip = ({ text, children }) => (
  <TooltipProvider delayDuration={150}><Tooltip><TooltipTrigger asChild>{children}</TooltipTrigger><TooltipContent className="max-w-xs text-xs">{text}</TooltipContent></Tooltip></TooltipProvider>
);

export const VariablePills = ({ onInsert }) => (
  <div className="flex flex-wrap gap-2" data-testid="variable-pills">
    {VARS.map((v) => (
      <button key={v} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => onInsert(`{${v}}`)} data-testid={`var-pill-${v}`}
        className="rounded-full border border-[#0284C7]/30 bg-sky-50 px-3 py-1 font-mono text-[11px] font-semibold text-[#0284C7] transition-colors hover:bg-[#0284C7] hover:text-white">
        {`{${v}}`}
      </button>
    ))}
  </div>
);

export const waToHtml = (s) => (s || "")
  .replace(/&/g, "&amp;").replace(/</g, "&lt;")
  .replace(/\*([^*\n]+)\*/g, "<b>$1</b>").replace(/_([^_\n]+)_/g, "<i>$1</i>").replace(/~([^~\n]+)~/g, "<s>$1</s>")
  .replace(/```([^`]+)```/g, "<code>$1</code>").replace(/\n/g, "<br/>");

export const fmtDuration = (s) => {
  if (!s || s < 60) return `${Math.round(s || 0)} detik`;
  const h = Math.floor(s / 3600), m = Math.round((s % 3600) / 60);
  return h ? `${h} jam ${m} menit` : `${m} menit`;
};

export const inputCls = "w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none transition-colors focus:border-[#D97706] focus:ring-2 focus:ring-[#D97706]/20";
